import React from 'react';
import { OtherDetailsType } from '.';
import { returnInputFieldLength } from '../../../../utils/commonFunctions';

type AppProps = {
  otherDetails: OtherDetailsType;
  handleOtherDetailsChange: (e: any) => void;
}

const OtherDetails = ({ otherDetails, handleOtherDetailsChange }: AppProps) => {

  const {
    udyogAadhar,
    professionalTaxEmployer,
    professionalTaxEmpoyee,
    serviceTaxNumber,
    iecCode,
    iacRegistration,
    startUpIndiaNumber,
    epfoNumber,
    esicNumber
  } = otherDetails;

  return (
    <>
      {/* Seventh Row */}
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Udyog Aadhar Number"
                  className={udyogAadhar ? "active" : ""}
                >Udyog Aadhar Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="udyogAadhar"
                  value={udyogAadhar}
                  onChange={(e) => handleOtherDetailsChange(e)}
                  maxLength={12}
                />
              </div>
              <span className="input-length">{returnInputFieldLength(udyogAadhar?.length, 12)}</span>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Professional Tax Employer"
                  className={professionalTaxEmployer ? "active" : ""}
                >Professional Tax (Employer)</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="professionalTaxEmployer"
                  value={professionalTaxEmployer}
                  onChange={(e) => handleOtherDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Professional Tax Employee"
                  className={professionalTaxEmpoyee ? "active" : ""}
                >Professional Tax (Person)</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="professionalTaxEmpoyee"
                  value={professionalTaxEmpoyee}
                  onChange={(e) => handleOtherDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* Eigth Row */}
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Service Tax Number"
                  className={serviceTaxNumber ? "active" : ""}
                >Service Tax Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="serviceTaxNumber"
                  value={serviceTaxNumber}
                  onChange={(e) => handleOtherDetailsChange(e)}
                  maxLength={15}
                />
              </div>
              <span className="input-length">{returnInputFieldLength(serviceTaxNumber?.length, 15)}</span>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="IEC Code"
                  className={iecCode ? "active" : ""}
                >IEC Code No.</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="iecCode"
                  value={iecCode}
                  onChange={(e) => handleOtherDetailsChange(e)}
                  maxLength={10}
                />
              </div>
              <span className="input-length">{returnInputFieldLength(iecCode?.length, 10)}</span>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="80-IAC Registration"
                  className={iacRegistration ? "active" : ""}
                >80-IAC Registration Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="iacRegistration"
                  value={iacRegistration}
                  onChange={(e) => handleOtherDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* Ninth Row */}
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Startup India Registration"
                  className={startUpIndiaNumber ? "active" : ""}
                >Startup India Registration Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="startUpIndiaNumber"
                  value={startUpIndiaNumber}
                  onChange={(e) => handleOtherDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="EPFO Number"
                  className={epfoNumber ? "active" : ""}
                >EPFO Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="epfoNumber"
                  value={epfoNumber}
                  onChange={(e) => handleOtherDetailsChange(e)}
                  maxLength={22}
                />
              </div>
              <span className="input-length">{returnInputFieldLength(epfoNumber?.length, 22)}</span>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="ESIC Number"
                  className={esicNumber ? "active" : ""}
                >ESIC Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="esicNumber"
                  value={esicNumber}
                  onChange={(e) => handleOtherDetailsChange(e)}
                  maxLength={17}
                />
              </div>
              <span className="input-length">{returnInputFieldLength(esicNumber?.length, 17)}</span>
            </div>
          </form>
        </div>
      </div>
    </>
  )
};

export default OtherDetails;